









































































































































import Vue from "vue";
import Price from "@/lib/price";
import Locale from "@/lib/locale";
import { Data, Method, Props } from "./PlanOptionDetailPayOtherLinkTypes";
import SalePriceGuide from "./SalePriceGuide.vue";
import ForeignSalePriceGuide from "@/components/PlanOptionDetail/ForeignSalePriceGuide.vue";

export default Vue.extend<Data, Method, {}, Props>({
  name: "vc-plan-option-detail-pay-other-link",
  components: {
    "vc-sale-price-guide": SalePriceGuide,
    "vc-foreign-sale-price-guide": ForeignSalePriceGuide
  },
  data() {
    var defaultCurrency = null;
    var defaultPrice = null;
    var defaultPriceText = null;
    var beforeDefaultPrice = null;

    for (const linkIndex in this.links) {
      if (this.links[linkIndex].currency == this.defaultCurrency) {
        defaultCurrency = this.links[linkIndex].currency;
        defaultPrice = this.prices[this.links[linkIndex].currency];
        beforeDefaultPrice = this.beforePrices[this.links[linkIndex].currency];
      }
    }
    if (defaultCurrency == null) {
      defaultCurrency = this.links[0].currency;
      defaultPrice = this.prices[this.links[0].currency];
      beforeDefaultPrice = this.beforePrices[this.links[0].currency];
    }

    defaultPrice = Price.getPrice(defaultCurrency, Number(defaultPrice));
    defaultPriceText = this.lang.note_price.replace(":price", defaultPrice);

    beforeDefaultPrice = Price.getPrice(
      defaultCurrency,
      Number(beforeDefaultPrice)
    );

    return {
      priceText: defaultPriceText,
      price: defaultPrice,
      beforePrice: beforeDefaultPrice,
      showDetail: this.initialShowDetail,
      currency: defaultCurrency,
      defaultLink: "",
      goldLink: "",
      locale: Locale.getLocale()
    };
  },
  props: {
    lang: { default: () => ({}) },
    prices: { default: () => ({}) },
    beforePrices: { default: () => ({}) },
    defaultCurrency: { default: "" },
    buttonMoreDetails: { default: "" },
    initialShowDetail: { default: false },
    isShowPlanList: { default: false },
    planListLink: { default: "" },
    planListText: { default: "" },
    isIce: { default: false },
    planKey: { default: "" },
    detailReplaceLink: { default: () => ({}) },
    links: { default: () => ({}) },
    fromPlanCategory: { default: undefined },
    isJapanSale: { default: false },
    isSale: { default: false }
  },
  mounted() {
    var defaultCurrencyIndex = 0;
    for (const linkNo in this.links) {
      if (this.links[linkNo].payment_method == "card_or_cs") {
        this.defaultLink = this.links[linkNo].url;
      } else if (this.links[linkNo].payment_method == "gold") {
        this.goldLink = this.links[linkNo].url;
      }
      if (this.currency == this.links[linkNo].currency) {
        defaultCurrencyIndex = Number(linkNo);
      }
    }
    if (this.defaultLink == "") {
      this.defaultLink = this.links[defaultCurrencyIndex].url;
    }
    if (this.isSale != false) {
      this.showDetail = true;
    }
  },
  methods: {
    async changeCurrency() {
      for (const linkNo in this.links) {
        if (this.currency == this.links[linkNo].currency) {
          this.price = Price.getPrice(
            this.currency,
            Number(this.prices[this.links[linkNo].currency])
          );
          this.priceText = this.lang.note_price.replace(":price", this.price);
          this.beforePrice = Price.getPrice(
            this.currency,
            Number(this.beforePrices[this.links[linkNo].currency])
          );
          this.defaultLink = this.links[linkNo].url;
        }
      }
    },
    async changeShowDetail() {
      this.showDetail = true;
    }
  }
});
